import React from "react";
import { NavLink } from "react-router-dom";
import classNames from "./Home.module.css";

import F from "../../assets/footer_icons/facebook.svg";
import I from "../../assets/footer_icons/instagram.svg";
import T from "../../assets/footer_icons/twitter.svg";
import Y from "../../assets/footer_icons/youtube.svg";
import P from "../../assets/footer_icons/pinterest.svg";

const Profile = () => {
  return (
    <>
      <div className={classNames.nav_container}>
        <div className={classNames.logo}>
          <NavLink to={"/"}>FMMF</NavLink>
        </div>
        <div className={classNames.nav}>
          <ul>
            <li>
              <NavLink to={"/"}>Round table meeting</NavLink>
            </li>
            <li>
              <NavLink to={"/"}>One to one</NavLink>
            </li>
            <li>
              <NavLink to={"/"}>Professional pairing</NavLink>
            </li>
            <li>
              <NavLink to={"/"}>Family meeting </NavLink>
            </li>
            <li>
              <NavLink to={"/"}>Consultation</NavLink>
            </li>
          </ul>
        </div>
        <div className={classNames.user}>
          {!localStorage.getItem("authToken") ? (
            <>
              <NavLink to={"/login"}>Login</NavLink>
              <NavLink to={"/signup"}>Signup</NavLink>
            </>
          ) : (
            <>
              <NavLink to={"/profile"}>Profile</NavLink>
              <NavLink to={"/signup"}>Logout</NavLink>
            </>
          )}
        </div>
      </div>
      <div className={classNames.hero_area}>
        <h1>Flawless Muslim</h1>
        <h1>Matrimony Functions</h1>
      </div>
      <div className={classNames.about}>
        <h1>Profile</h1>
      </div>
      <div className={classNames.footer}>
        <p>All rights reserved || © Flawless Muslim Matrimony Functions</p>
        <div className={classNames.icons}>
          <ul>
            <li>
              <a
                href="https://www.facebook.com/flawless.muslim.matrimony.functions"
                target={"_blank"}
                rel="noreferrer"
              >
                <img src={F} alt="Icon" />
              </a>
            </li>
            <li>
              <a href="!#" target={"_blank"} rel="noreferrer">
                <img src={I} alt="Icon" />
              </a>
            </li>
            <li>
              <a href="!#" target={"_blank"} rel="noreferrer">
                <img src={T} alt="Icon" />
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/@fmmf2022"
                target={"_blank"}
                rel="noreferrer"
              >
                <img src={Y} alt="Icon" />
              </a>
            </li>
            <li>
              <a href="!#" target={"_blank"} rel="noreferrer">
                <img src={P} alt="Icon" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Profile;
